module.exports = "<div class=\"room\">\n    <office *ngFor=\"let o of offices\" [office] =\"o\"></office>\n</div>"